import React from 'react';
import { useTheme } from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Small } from '@finect/tabular-core/Small';
import { MessageSquare } from '@finect/tabular-icons/messageSquare';
import { getQuestionPath } from '../../utils';
import { Inner, Title, IconBlock } from './partials';
export var SmallQuestion = function SmallQuestion(_ref) {
  var question = _ref.question;
  var theme = useTheme();
  var path = getQuestionPath(theme, question);
  var title = question.title,
    answers = question.answers;
  return React.createElement(Inner, null, React.createElement(IconBlock, null, React.createElement(MessageSquare, {
    size: "36"
  })), React.createElement("div", null, React.createElement(Title, {
    href: path.url,
    "data-fi-event": "question-title",
    title: "Ver respuestas a la pregunta: ".concat(title)
  }, title), React.createElement("div", null, React.createElement(Small, null, 'Ver ', React.createElement(AppLink, {
    href: path.url,
    title: "Ver respuestas a la pregunta \"".concat(title, "\"")
  }, answers.length, " respuesta", answers.length !== 1 ? 's' : '')))));
};